import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";

export const useAuthCheck = (scopes) => {
    const { instance, accounts } = useMsal();
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
      // Retrieve the authentication state from local storage
      return localStorage.getItem('isAuthenticated') === 'true';
    });
    const [isCheckingAuth, setIsCheckingAuth] = useState(() => {
      // Retrieve the authentication state from local storage
      return localStorage.getItem('isCheckingAuth') !== null && localStorage.getItem('isCheckingAuth') !== false;
    });
    const [accessToken, setAccessToken] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        //no, this cannot work. When you reload the page:
        // The MSAL (Microsoft Authentication Library) needs to re-initialize and validate the authentication tokens
        // The authentication state is managed in memory and needs to be re-established from the cached tokens
        // if (isAuthenticated)
        // {
        //     setIsAuthenticated(true);
        //     localStorage.setItem('isAuthenticated', true);
        //     setIsCheckingAuth(false);
        //     localStorage.setItem('isCheckingAuth', false);
        //     return;
        // }
        const checkAuth = async () => {
            if (accounts.length > 0) {
                setIsAuthenticated(true);
                localStorage.setItem('isAuthenticated', true);
                try {
                    const response = await instance.acquireTokenSilent({
                        scopes: scopes,
                        account: accounts[0],
                    });
                    setAccessToken(response.accessToken);
                    setError(null);
                } catch (err) {
                    setError(err);
                    //Handle error, e.g., try interactive login if silent fails
                }
            } else {
                setIsAuthenticated(false);
                localStorage.setItem('isAuthenticated', false);
                setAccessToken(null);
            }
            setIsCheckingAuth(false);
            localStorage.setItem('isCheckingAuth', false);
        };
        checkAuth();
    }, [instance, accounts, scopes]);

    const login = async () => {
        try {
            await instance.loginRedirect({ scopes: scopes });
        } catch (err) {
            setError(err);
        }
    };

    const logout = async () => {
        instance.logoutRedirect();
    };

    return { isCheckingAuth, isAuthenticated, accessToken, error, login, logout };
};

export default useAuthCheck;
